import { PersonType } from '@api';
import {
  EmailAnchor,
  PhoneNumberAnchor,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { PrivateInformationTableRowType } from '../../data';
import { useGetRowValues } from './hooks';

type PrivateInformationTableRowPropsType = {
  personDetails: PersonType;
  row: PrivateInformationTableRowType;
};

export const PrivateInformationTableRow: React.FC<
  PrivateInformationTableRowPropsType
> = ({ personDetails, row }) => {
  const { t } = useTranslation('personDetailsGeneral');

  const { getRowValues } = useGetRowValues({ personDetails });

  const label = t(
    `PRIVATE_INFORMATION.PRIVATE_INFORMATION_TABLE.ROWS.${row.label}`
  );
  const value = getRowValues(row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'contact.mobile':
      case 'contact.phone':
        return <PhoneNumberAnchor phoneNumber={value} />;
      case 'contact.email':
        return <EmailAnchor email={value} />;
      default:
        return value;
    }
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
